import moment from "moment-timezone";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import useClickOutside from "../Hooks/UseClickOutside";
import { format } from "date-fns";
import { AuthContext } from "../contexts/AuthContext";
import OtpVerification from "./OtpVerification";
import axiosHttp from "../config/axios.interceptor";
import { useDispatch } from "react-redux";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { errorResponseMessage } from "../shared/const.prop";

const UpcomingSingleSession = ({
  item,
  cancellationHandler,
  rescheduleHandler,
}) => {
  const [isOpen, toggle, containerRef] = useClickOutside(false);
  const navigate = useNavigate();
  const myZone = localStorage.getItem("zone");
  const dispatch = useDispatch();
  const authContext = useContext(AuthContext);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [isOtpDisabled, setIsOtpDisabled] = useState(false);
  const [verificationKey, setVerificationKey] = useState("");
  const { user } = authContext;

  const formatTime = (time) => {
    return moment(time).tz(item.zone?.[0]).format("h:mm A");
  };

  const subscriptionPlan =
    user?.subscription?.main_plan_name ||
    user?.data?.data?.subscription?.main_plan_name;

  // console.log(item);

  const date = moment(item?.start_time).tz(item.zone?.[0]);
  const endTimeMoment = moment(item?.end_time).tz(item.zone?.[0]);
  const currentTime = moment();

  const todayStart = moment().startOf("day");
  const todayEnd = moment().endOf("day");

  const startTimeHours = date.hours();
  const startTimeMinutes = date.minutes();
  const endTimeHours = endTimeMoment.hours();
  const endTimeMinutes = endTimeMoment.minutes();
  const currentHours = currentTime.hours();
  const currentMinutes = currentTime.minutes();

  const startTimeInMinutes = startTimeHours * 60 + startTimeMinutes;
  const endTimeInMinutes = endTimeHours * 60 + endTimeMinutes;
  const currentInMinutes = currentHours * 60 + currentMinutes;

  const fiveMinutesBeforeStartTimeInMinutes = startTimeInMinutes - 5;

  const isWithinToday =
    date.isBetween(todayStart, todayEnd) &&
    endTimeMoment.isBetween(todayStart, todayEnd);

  const isWithinRange =
    isWithinToday &&
    currentInMinutes >= fiveMinutesBeforeStartTimeInMinutes &&
    currentInMinutes <= endTimeInMinutes;

  const navigateHandler = () => {
    window.location.href = item?.meetLink;
  };

  const currentTimeString = currentTime.format("YYYY-MM-DDTHH:mm:ss") + "Z";

  const isValid =
    currentTimeString >=
    moment(item.start_time).format("YYYY-MM-DDTHH:mm:ss") + "Z";

  const isMentor = () => {
    return (
      user?.userId === item?.mentor_id ||
      user?.data?.data?.userId === item?.mentor_id
    );
  };

  const openOtpHandler = (key) => {
    setVerificationKey(key);
    setIsOtpModalOpen(true);
  };

  const handleOtpSubmit = async (otp) => {
    setIsOtpDisabled(true);
    let url = verificationKey === "startotp" ? "start-otp" : "end-otp";
    const payload = {
      appointment_id: item?.id,
      [verificationKey === "startotp" ? "start_otp" : "end_otp"]: otp,
    };
    try {
      const verifyOTP = await axiosHttp.post(`appointment/${url}`, payload);
      if (verifyOTP.status === 200) {
        setIsOtpDisabled(false);
        setIsOtpModalOpen(false);
        appContext.updateNotificationState({
          show: true,
          message: "OTP verified successfully",
          type: "success",
        });
        setVerificationKey("");
        dispatch(getActiveNotificationCount());
        dispatch(getActiveChatNotificationCount());
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return (
    <div className="session-card mb-4">
      <div className="row m-auto">
        <div className="d-flex align-items-center justify-content-center w-100">
          <div className="w-35">
            <p className="box-txt mb-0">
              {moment(item.end_time).tz(item.zone?.[0]).format("DD/MM/YYYY")}
            </p>
          </div>
          <div className="w-50">
            <div className="d-flex align-items-center justify-content-center flex-wrapper-change">
              <input
                type="text"
                className="form-control border-0 text-center size-small"
                placeholder="9:00 AM"
                value={formatTime(item.start_time)}
              />
              <span className="mt-2 mx-3">-</span>
              <input
                type="text"
                className="form-control border-0 text-center size-small"
                placeholder="10:00 PM"
                value={formatTime(item.end_time)}
              />
            </div>
          </div>
          <div className="w-15 text-right">
            {isWithinRange && item?.meetLink ? (
              <p
                className="cursor-pointer m-auto join-btn rounded-pill"
                onClick={navigateHandler}
              >
                Join
              </p>
            ) : (
              <p
                title={
                  item.status === "C"
                    ? "Completed"
                    : item.status === "R"
                    ? "Cancelled"
                    : item.status === "S"
                    ? "Rescheduled"
                    : item.status === "B"
                    ? "Booked"
                    : item.status === "H"
                    ? "Hold"
                    : item.status === "M"
                    ? "Missed"
                    : "-"
                }
                className={`m-auto ${
                  item.status === "R"
                    ? "cancelled"
                    : item.status === "S"
                    ? "rescheduled"
                    : item.status === "C"
                    ? "completed"
                    : ""
                }`}
              >
                {item.status === "S"
                  ? "R"
                  : item.status === "R"
                  ? "C"
                  : item.status}
              </p>
            )}
          </div>
          <div className="w-15 text-right">
            {!isValid && (item.status !== "R" || item.status === "C") && (
              <div ref={containerRef}>
                <div className="dropdown book-edit" onClick={toggle}>
                  <span className="cursor-pointer">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="4"
                      height="17"
                      viewBox="0 0 4 17"
                      fill="none"
                    >
                      <circle cx="2" cy="2" r="2" fill="#000"></circle>
                      <circle cx="2" cy="8" r="2" fill="#000"></circle>
                      <circle cx="2" cy="15" r="2" fill="#000"></circle>
                    </svg>
                  </span>
                  {isOpen && (
                    <div className="schedule-options">
                      {/* {item.status !== "S" && ( */}
                      {subscriptionPlan === "Premium" && (
                        <span
                          className="dropdown-item cursor-pointer"
                          onClick={() => rescheduleHandler(item)}
                        >
                          Re-schedule
                        </span>
                      )}
                      {/* )} */}
                      <span
                        className="dropdown-item cursor-pointer"
                        onClick={() => cancellationHandler(item)}
                      >
                        Cancel
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {/* {isMentor() && isWithinRange && item?.meetLink && (
            <div className="w-15 text-right">
              <div ref={containerRef}>
                <div className="dropdown book-edit" onClick={toggle}>
                  <span className="cursor-pointer">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="4"
                      height="17"
                      viewBox="0 0 4 17"
                      fill="none"
                    >
                      <circle cx="2" cy="2" r="2" fill="#000"></circle>
                      <circle cx="2" cy="8" r="2" fill="#000"></circle>
                      <circle cx="2" cy="15" r="2" fill="#000"></circle>
                    </svg>
                  </span>
                  {isOpen && (
                    <div className="schedule-options">
                      <span
                        className="dropdown-item cursor-pointer"
                        onClick={() => openOtpHandler("startotp")}
                      >
                        Start OTP
                      </span>
                      <span
                        className="dropdown-item cursor-pointer"
                        onClick={() => openOtpHandler("endotp")}
                      >
                        End OTP
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>
      {/* {isWithinRange && item?.meetLink && (
        <OtpVerification
          isOpen={isOtpModalOpen}
          onClose={() => setIsOtpModalOpen(false)}
          onSubmit={handleOtpSubmit}
          isOtpDisabled={isOtpDisabled}
          resendOtpHandler={null}
          title={`Enter the ${
            verificationKey === "startotp"
              ? "Start"
              : verificationKey === "endotp"
              ? "End"
              : null
          } session OTP`}
          description="Get the OTP from the participant and verify the session"
          isResend={false}
          btnTxt="Submit"
          isSessionVerification={true}
        />
      )} */}
    </div>
  );
};

export default UpcomingSingleSession;
